import { getTabsStatePropsCreateSelector } from './../../helpers/tabsHelper';
import { connect } from 'react-redux';
import { onChangeTab } from './events/onChangeTab';
import { IApplicationState } from '../../../../../../types/types';
import { AsidePanelTabs } from '../../components/AsidePanelTabs/AsidePanelTabs';
import { IAsidePanelTabsDispatchProps, IAsidePanelTabsStateProps } from '../../components/AsidePanelTabs/types';
import { IAsidePanelTabsHOCOwnProps } from './types';
import { onClick } from './events/onClick';
import { getAsidePanelWidth } from '../../store/selectors/getAsidePanelWidth';
import { getNavigationPanelWidthSelector } from '../../../../main/navigationPanel/store/selectors/getNavigationPanelWidthSelector';
import { showHint } from './events/showHint';

const mapStateToProps = () => {
    const getTabsStateProps = getTabsStatePropsCreateSelector();

    return (
        state: IApplicationState,
        props: IAsidePanelTabsHOCOwnProps
    ): IAsidePanelTabsStateProps => {
        const { activeTabIndex, tabs: tabsProps } = props;
        const tabs = getTabsStateProps(tabsProps);

        return {
            activeTabIndex,
            asidePanelWidth: getAsidePanelWidth(state),
            navigationPanelWidth: getNavigationPanelWidthSelector(state),
            tabs: tabs.map(tab => {
                return {
                    ...tab,
                    icon: tab.getIcon ? tab.getIcon(state) : null,
                };
            }),
        }
    };
};

const mapDispatchToProps = (
    dispatch: any,
    ownProps: IAsidePanelTabsHOCOwnProps
): IAsidePanelTabsDispatchProps => {
    const { tabs, onTabChange, activeTabIndex } = ownProps;
    return {
        onChange: (
            index,
            prevIndex,
            cardId
        ) => dispatch(onChangeTab(index, prevIndex, cardId, onTabChange, tabs)),
        onClick: (onClickOwn) => dispatch(onClick(tabs[activeTabIndex].route, onClickOwn)),
        showHint: (show) => dispatch(showHint(show)),
    }
};

export const AsidePanelTabsHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(AsidePanelTabs);

AsidePanelTabsHOC.displayName = 'AsidePanelTabsHOC';
